import { mainAppRoutes } from '@packages/shared/core/common/constants/routes';
import { useServices } from '@packages/shared/core/common/hooks/useServices';
import { appendQueryParams } from '@packages/shared/core/common/utils/url/appendQueryParams';

export function useRedirectToMainApp() {
  const { featureFlags } = useServices();

  const withSplitId = (url: string) => {
    const splitId = featureFlags.getSplitId();

    return splitId ? appendQueryParams(new URL(url), { split_id: splitId }).href : url;
  };

  function getCookiePolicyPagePath() {
    return mainAppRoutes.cookiePolicy;
  }

  function getTermsPagePath() {
    return mainAppRoutes.terms;
  }

  function getPrivacyPagePath() {
    return mainAppRoutes.privacy;
  }

  function getMoneyBackPolicyPagePath() {
    return mainAppRoutes.moneyBackPolicy;
  }

  function getFAQPagePath() {
    return mainAppRoutes.FAQ;
  }

  function getSupportPath() {
    return mainAppRoutes.support;
  }

  function getLoginPath() {
    return mainAppRoutes.login;
  }

  function redirectToExpertsPage() {
    window.location.assign(withSplitId(mainAppRoutes.experts));
  }

  async function redirectToSignupCreditsPage() {
    await window.location.assign(withSplitId(mainAppRoutes.signupCredits));
  }

  async function redirectToSignupFreeTrialPage() {
    await window.location.assign(withSplitId(mainAppRoutes.signupFreeTrial));
  }

  async function redirectToExpertChat(expertId: string) {
    await window.location.assign(withSplitId(`${mainAppRoutes.expertChat}${expertId}`));
  }

  async function redirectToCommandsPage(command: string) {
    await window.location.assign(withSplitId(`${mainAppRoutes.commands}${command}`));
  }

  async function redirectToLoginPage() {
    await window.location.assign(withSplitId(mainAppRoutes.login));
  }

  function getFullDisclaimerPagePath() {
    return mainAppRoutes.fullDisclaimer;
  }

  function getImpressumPagePath() {
    return mainAppRoutes.impressum;
  }

  function getLegalCenterPagePath() {
    return mainAppRoutes.legalCenter;
  }

  return {
    redirectToExpertsPage,
    getCookiePolicyPagePath,
    getTermsPagePath,
    getPrivacyPagePath,
    getMoneyBackPolicyPagePath,
    getFAQPagePath,
    getLoginPath,
    redirectToLoginPage,
    redirectToExpertChat,
    getSupportPath,
    redirectToSignupCreditsPage,
    redirectToSignupFreeTrialPage,
    redirectToCommandsPage,
    getFullDisclaimerPagePath,
    getImpressumPagePath,
    getLegalCenterPagePath,
  };
}
